<template>
    <span>
        <v-btn outlined type="button" @click="initSendUserNotifications()" color="primary" :disabled="processing" :loading="processing" class="mx-1">Send New User Notifications</v-btn>
        <confirm-dialog ref="confirmUsersDialog"></confirm-dialog>
    </span>
</template>

<script>

import api from '@/api';
import SearchUsers from "../user/SearchUsers";
import ConfirmDialog from "@/components/common/ConfirmDialog";
export default {
    name: "OrganizationSendNewUserNotifications",
    components:{SearchUsers, ConfirmDialog},
    props: {
        organizationId : Number
    },
    data() {
        return {
            processing : false
        }
    },
    methods: {
        initSendUserNotifications() {
            this.$refs.confirmUsersDialog.open('Send New User Notifications', `This Will Send E-Mail Notifications to all Users Who Have Not Yet Accessed First Alert.
            For Security Purposes, New Passwords Will Be Generated For Each User.  Are You Sure You Want to do This?`).then((confirm) => {
                if (confirm) {
                    this.sendNewUserNotifications();
                }
            });

        },
        sendNewUserNotifications() {
            const object = {
                type:'FIRST_TIME'
            }
            const organizationId = this.organizationId;
            this.processing = true;
            api.organization.newUserNotifications(organizationId, object).then((result) => {
                const count = result.count;
                this.$root.$emit('globalMessage',`E-Mails Sent to ${count} Users.`);
            },(error) => {
                this.$root.$emit('globalError','An Error Occurred Sending New User E-Mails');
            }).finally(()=> {
                this.processing = false;
            });
        }
    }
}
</script>

<style scoped>

</style>